import * as angular from 'angular';
import * as ngSanitize from 'angular-sanitize';

export interface IUploadFileApi {
  appRoot: string;

  Upload;

  uploadFiles(file, resourceData);
}

import CoreModule from '../core/core.module';

import * as _ from 'lodash';

import { ColumnsOnOfferComponent } from './columnsOnOffer.component';
import { FileHeadersComponent } from './fileHeaders.component';
import FileParserService from './fileParser.service';
import { ImportPricingNavComponent } from './importPricingNav.component';
import { ImportSuccessModalComponent } from './importSuccessModal.component';
import { PricingHeaderCellComponent } from './pricingHeaderCell.component';
import { SelectColumnsPaneComponent } from './selectColumnsPane.component';
import { SelectTabPaneComponent } from './selectTabPane.component';
import { SummaryPaneComponent } from './summaryPane.component';
import { SummaryPaneService } from './summaryPane.service';
import UploadModelService from './uploadModel.service';
import UploadOfferPricingFileService from './UploadOfferPricingFile.service';

export default angular
  .module('UploadSpreadsheetApp', [ngSanitize, CoreModule, 'ngFileUpload'])
  .component('columnsOnOffer', ColumnsOnOfferComponent)
  .component('fileHeaders', FileHeadersComponent)
  .service('FileParser', FileParserService)
  .component('importPricingNav', ImportPricingNavComponent)
  .component('importSuccessModal', ImportSuccessModalComponent)
  .component('pricingHeaderCell', PricingHeaderCellComponent)
  .component('selectColumnsPane', SelectColumnsPaneComponent)
  .component('selectTabPane', SelectTabPaneComponent)
  .component('summaryPane', SummaryPaneComponent)
  .service('SummaryPaneService', SummaryPaneService)
  .service('UploadModel', UploadModelService)
  .service('UploadOfferPricingFile', UploadOfferPricingFileService).name;
